import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const ROLE_LABELS = {
  SUPERADMIN: "Superadministrador",
  DIRECAO: "Direção",
  COORDENACAO: "Coordenação",
  PROFESSOR: "Professor",
  COZINHEIRA: "Cozinheira",
};

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, obj = authed
  const [schools, setSchools] = useState([]);
  const [selectedSchoolId, setSelectedSchoolId] = useState(
    localStorage.getItem("acompanha_school") || ""
  );

  const loadSchools = useCallback(async (u) => {
    if (!u) return;
    try {
      const { data } = await api.get("/schools");
      setSchools(data);
      if (u.role !== "SUPERADMIN") {
        setSelectedSchoolId(u.school_id || "");
      } else if (!localStorage.getItem("acompanha_school") && data.length) {
        setSelectedSchoolId(data[0].id);
      }
    } catch (e) {
      /* noop */
    }
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
        await loadSchools(data);
      } catch {
        setUser(false);
      }
    })();
  }, [loadSchools]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data.user);
    await loadSchools(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setUser(false);
    setSchools([]);
  };

  const chooseSchool = (id) => {
    setSelectedSchoolId(id);
    localStorage.setItem("acompanha_school", id);
  };

  // school_id to send on scoped requests (superadmin can view "all" with empty)
  const isSA = !!user && user.role === "SUPERADMIN";
  const scopeKey = isSA ? selectedSchoolId : "";
  const scopeParams = useMemo(() => (scopeKey ? { school_id: scopeKey } : {}), [scopeKey]);
  const value = useMemo(() => ({
    user, setUser, login, logout, schools, setSchools, loadSchools,
    selectedSchoolId, chooseSchool, scopeParams, isSuperadmin: isSA,
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }), [user, schools, selectedSchoolId, scopeParams, isSA, loadSchools]);

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}
